import { FC, useEffect, useState } from "react";

import classes from "./LeaderBoardHeader.module.css";
import { getLang, i18n } from "../../i18n";

interface Props {
  place: number;
}

const LeaderBoardHeader: FC<Props> = ({ place }) => {
  const lang = getLang();
  const t = i18n.leaderboardHeader[lang];

  const [sticky, setSticky] = useState(false);
  const handleScroll = () => {
    setSticky(document.documentElement.scrollTop >= 44);
  };
  useEffect(() => {
    console.log("leaderboard use effect");
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        className={`${classes.sectionHeader} ${sticky ? classes.sticky : ""}`}
      >
        <div className={classes.headerTop}>
          <h1>{t.leaderboard}</h1>
        </div>
        <div className={classes.winrate}>
          <div className={classes.label}>{t.yourPlace}</div>
          <div className={classes.value}>{place === 0 ? "1000+" : place}</div>
        </div>
      </header>
    </>
  );
};

export default LeaderBoardHeader;
